import type NonEmptyText from './non-empty-text';
import { assertIsInstanceOfNonEmptyText } from './assertions';

interface ISelf {
	readonly self: NonEmptyText;
}

export default class Self implements ISelf {
	public get self(): NonEmptyText {
		return this.#self;
	}

	#self: NonEmptyText;
	public constructor({ self }: ISelf) {
		assertIsInstanceOfNonEmptyText(self);
		this.#self = self;
	}
}
